import React, { useContext, useState } from "react";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import Img from "../Img";
import { classIf } from "../../data/utils";

export default function MultiBonus(props) {
    const betslipContext = useContext(BetslipContext) ;
    const [toggled, setToggled] = useState(true);
    let betslipData = betslipContext.getBetslipData();
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const showAdvise = coupon.selectedContainer === 'multibets' && betslipContext.toGetBonusAdvise?.showAdvise;

    if (!showAdvise) {
        return null;
    }

    const data = betslipContext.toGetBonusAdvise;
    const total = data.nextBonusThreshold > 5? 5 : data.nextBonusThreshold;
    const selected = total - data.eventLeftToGetBonus;
    const percentage = data.reachingPercentage;
    const percentageUnlocked = data.reachedPercentage;
    const percentageText = `${percentage}%`;

    let progressBars = [];
    for (let i = 0; i < total; i++) {
        progressBars.push(
            <div key={i} className={"b_9_3_1_1" + classIf(i < selected, 'active')}></div>
        );
    }

    return (
        <>
            <div className="b_9">
                <div className="b_9_1" onClick={() => setToggled(!toggled)}>
                    <Img className="b_9_1_1" src="icon_bonus_betslip.svg" height="16px" width="16px" />
                    <div className="b_9_1_2">{percentageUnlocked ? percentageUnlocked + '% Bonus Unlocked' : coupon.multipleBonus.description}</div>
                    <Img className="b_9_1_3" src="icon_chevron.svg" height="24px" width="24px" data-rotate={toggled ? '180' : '0'} />
                </div>
                {toggled &&
                    <div className="b_9_2">
                        {/* TODO handle highlighted text */}
                        {/* Add 1 more pre-match selections with minimum odds of 1.25 for <span className="b_9_2_1 active">5% BONUS!</span> */}
                        {data.bonusAdvise}
                    </div>
                }
     
                <div className="b_9_3">
                    <div className="b_9_3_1">
                        {progressBars}
                    </div>
                    <div className="b_9_1_3">
                        <span className="b_9_1_3_1" data-chars={percentageText.length}>{percentageText}</span>
                        <Img className="b_9_1_3_2" src="icon_badge_bonus.svg" height="100%" width="100%" />
                    </div>
                </div>
                
            </div>
        </>
    );
}
